import { render, staticRenderFns } from "./ModalCreateBMHC.vue?vue&type=template&id=087c7c2c"
import script from "./ModalCreateBMHC.vue?vue&type=script&lang=js"
export * from "./ModalCreateBMHC.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateBMHC.vue?vue&type=style&index=0&id=087c7c2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports